module.exports = __webpack_public_path__ + "img/publish_bg.33bf700.png";